var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.view === 'modern')?_c('startpage-modern',{attrs:{"categories":_vm.categories,"mainbody":_vm.mainbody,"heading":_vm.heading}}):_c('startpage-classic',{attrs:{"categories":_vm.categories,"mainbody":_vm.mainbody}})}
var staticRenderFns = []

export { render, staticRenderFns }